/* Forged Racing — shared cheap-addon selector.

   ROUND 33 (Emirali, twice over):
     cart  — "in the cart upsell make it more afordable items no like wheelsets
              cuz people dont just add that on"
     PDP   — "a product addon area in each item page and it has to be smart
              like if its a surron chaindrive it recomends surron pegs"

   ONE engine, two consumers: the cart drawer's Complete-the-build block and the
   PDP addon box. Written once here so the two can never drift apart.

   WHAT THE CART UPSELL DID BEFORE
   Shopify's /recommendations/products.json with intent=complementary, seeded on
   the FIRST cart item, filtered only by "not already in cart" and "available".
   No price filter at all — which is exactly why wheelsets were being offered as
   an add-on to a $12 bolt kit.

   SOURCING STRATEGY — recommendations first, collections as the floor.

   1. Shopify's own recommendation engine for the seed product (complementary,
      then related). This is the "smart" part and it costs nothing to maintain:
      Shopify derives it from real co-purchase behaviour, so it improves on its
      own as orders accumulate and it covers new products automatically.

   2. Top up from cheap-accessory COLLECTIONS when step 1 doesn't yield enough
      that pass the filters. Collection handles, never product IDs — the brief
      forbids a hardcoded product list, and a collection keeps working as the
      catalog grows. The Warp 9 import (155+ products) lands in collections and
      is picked up with no code change.

   Both passes go through the same filter, so the price ceiling and the
   exclusions apply no matter which source a product came from.

   WHY NOT BIKE-FITMENT TAGS. Measured across the live catalog before choosing —
   see the round report for the coverage numbers. Fitment data was not
   consistently populated enough to build on, and the brief pre-decided that
   under ~60% coverage means collection-based instead. A rule that works
   everywhere beats one that's clever on part of the catalog.

   No hand-maintained mapping anywhere in here. That was also pre-ruled-out, and
   it's the right call: a type-to-type pairing table is a cost Dario would carry
   for the life of the store. */
(function () {
  'use strict';

  /* ROUND 40 — was a hardcoded 4000. Emirali's ask is "affordable", and $40 was
     the line where an add-on stops being an impulse and starts being a decision;
     that is a merchandising judgement, so it belongs to him, not to this file.

     Reads from window.ForgedConfig (snippets/forged-config.liquid), which is
     inline and therefore already parsed by the time this deferred script runs.
     The literal survives only as the fallback for the case where the snippet is
     somehow absent — losing the ceiling entirely would let a $900 wheelset into
     an "affordable add-ons" row, which is the exact complaint this cap exists
     to answer. */
  var CFG = (window.ForgedConfig && window.ForgedConfig.upsell) || {};
  var MAX_CENTS = (typeof CFG.maxCents === 'number' && CFG.maxCents > 0) ? CFG.maxCents : 4000;

  /* Categories that are never impulse buys regardless of price. Matched against
     product_type AND title, because this catalog's product_type is inconsistent
     — some wheelsets carry no type at all, so a type-only check would let them
     through. Deliberately generous: a false exclusion costs one slot, a false
     inclusion is the exact thing being complained about. */
  var EXCLUDE = /(wheelset|wheel\b|supermoto|battery|controller|motor\b|fork\b|shock|suspension|frame|swing ?arm|bike\b|complete kit)/i;

  /* Cheap-accessory collections used to top up. Handles, not products. Ordered
     by how impulse-y they are.

     ROUND 40 — was a hardcoded array. These are collection handles baked into
     JS, which is the failure mode the duplicate-collection merges are about to
     trigger: merge or rename any of these four and this list silently stops
     matching, with no error anywhere, just a thinner upsell row.

     Now editable in Theme settings as a comma-separated list. The literal
     remains as the fallback, and blank entries are stripped because a trailing
     comma in a text setting is the most likely way this gets typed. */
  var FALLBACK_COLLECTIONS = (function () {
    var fromCfg = CFG.fallbackCollections;
    if (Object.prototype.toString.call(fromCfg) === '[object Array]') {
      var cleaned = [];
      for (var i = 0; i < fromCfg.length; i++) {
        var h = String(fromCfg[i] || '').trim();
        if (h) cleaned.push(h);
      }
      if (cleaned.length) return cleaned;
    }
    return ['stickers', 'accessories', 'footlocks', 'titanium-hardware'];
  }());

  var collectionCache = {};

  /* Variant price in cents. The recommendations endpoint reports variant
     prices as integer cents; /collections/x/products.json reports them as a
     decimal string ("12.99"). */
  function variantCents(v) {
    if (!v || typeof v !== 'object') return NaN;
    return typeof v.price === 'number' ? v.price : Math.round(parseFloat(v.price) * 100);
  }

  /* ROUND 85 T7 — the ONE variant an add-on offers and adds: the cheapest
     AVAILABLE one. Before this the box priced and added variants[0], which on
     ultra-upgraded-levers is $60.99 while the product starts at $34.99 — and
     the $40 ceiling below was tested against the product minimum, so a $60.99
     line got through an "affordable" filter. Price shown, price charged and
     the price the ceiling tests are now all the same variant.
     varies = the AVAILABLE variants differ in price, which is when "From" is
     true. Returns null when nothing is buyable. */
  function offerFor(p) {
    var vs = (p && p.variants) || [];
    var best = null;
    var seen = {};
    var distinct = 0;
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i];
      if (!v || typeof v !== 'object' || v.available === false) continue;
      var c = variantCents(v);
      if (!isFinite(c) || c <= 0) continue;
      if (!seen[c]) { seen[c] = true; distinct++; }
      if (!best || c < best.cents) best = { id: v.id, cents: c };
    }
    if (best) best.varies = distinct > 1;
    return best;
  }

  function passes(p, inCartIds) {
    if (!p || !p.available) return false;
    if (inCartIds.indexOf(p.id) !== -1) return false;
    /* R85 T7: test the variant that will actually be offered. Falls back to
       the product-level price only if the payload carries no variants. */
    var offer = offerFor(p);
    var cents = offer ? offer.cents
              : ((p.variants && p.variants.length) ? NaN
              : (typeof p.price === 'number' ? p.price : parseInt(p.price, 10)));
    if (!isFinite(cents) || cents <= 0 || cents > MAX_CENTS) return false;
    var hay = (p.title || '') + ' ' + (p.product_type || '');
    if (EXCLUDE.test(hay)) return false;
    return true;
  }

  function fetchJSON(url) {
    return fetch(url).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  function fromRecommendations(seedId, intent) {
    if (!seedId) return Promise.resolve([]);
    return fetchJSON('/recommendations/products.json?product_id=' + seedId + '&intent=' + intent + '&limit=10')
      .then(function (d) { return (d && d.products) || []; });
  }

  function fromCollection(handle) {
    if (collectionCache[handle]) return Promise.resolve(collectionCache[handle]);
    return fetchJSON('/collections/' + handle + '/products.json?limit=50').then(function (d) {
      var list = (d && d.products) || [];
      /* /collections/x/products.json reports price on the variant, as a decimal
         STRING ("12.99"), not cents on the product like the recommendations
         endpoint. Normalise here so passes() sees one shape. */
      list = list.map(function (p) {
        var v = p.variants && p.variants[0];
        return {
          id: p.id,
          title: p.title,
          product_type: p.product_type,
          url: '/products/' + p.handle,
          price: v ? Math.round(parseFloat(v.price) * 100) : NaN,
          available: !!(v && v.available),
          featured_image: (p.images && p.images[0] && p.images[0].src) || '',
          variants: p.variants || []
        };
      });
      collectionCache[handle] = list;
      return list;
    });
  }

  /* opts: { seedId, inCartIds, limit }
     Resolves to an array of products already filtered and de-duplicated.
     Never rejects — a dead endpoint yields fewer items, never a broken box. */
  function pick(opts) {
    opts = opts || {};
    var seedId = opts.seedId || null;
    var inCart = opts.inCartIds || [];
    var limit = opts.limit || 4;
    var out = [];
    var seen = {};

    function absorb(list) {
      for (var i = 0; i < list.length && out.length < limit; i++) {
        var p = list[i];
        if (seen[p.id]) continue;
        if (!passes(p, inCart)) continue;
        seen[p.id] = true;
        out.push(p);
      }
    }

    return fromRecommendations(seedId, 'complementary')
      .then(function (list) {
        absorb(list);
        if (out.length >= limit) return null;
        return fromRecommendations(seedId, 'related').then(absorb);
      })
      .then(function () {
        if (out.length >= limit) return null;
        /* Sequential, not parallel: usually the first collection is enough, and
           firing four requests to fill one slot is wasteful. */
        return FALLBACK_COLLECTIONS.reduce(function (chain, handle) {
          return chain.then(function () {
            if (out.length >= limit) return null;
            return fromCollection(handle).then(absorb);
          });
        }, Promise.resolve());
      })
      .then(function () { return out; })
      .catch(function () { return out; });
  }

  window.ForgedUpsell = {
    pick: pick,
    passes: passes,
    offerFor: offerFor,
    MAX_CENTS: MAX_CENTS,
    EXCLUDE: EXCLUDE
  };
})();
